<template>
  <p
    v-if="mgnlProps.openCookies"
    class="mt-lg cursor-pointer text-sm font-light hover:underline mobile:my-lg"
    v-bind="$attrs"
    tabindex="0"
    @click="openCookieSettings"
  >
    {{ link.name }}
  </p>
  <template v-else>
    <SharedLink
      v-if="
        magnoliaGetters.showKioskOrCatalog($flags, mgnlProps.showLinkKiosk ?? false, mgnlProps.showLinkCatalog ?? false)
          && (!mgnlProps.showLinkLoyalty || mgnlProps.showLinkLoyalty)
      "
      class="mt-lg cursor-pointer text-sm font-light hover:underline mobile:my-lg"
      :class="{ 'text-primary-700': mgnlProps.emphasis }"
      :link="link"
      v-bind="$attrs"
    >
      {{ link.name }}
    </SharedLink>
  </template>
</template>

<script lang="ts" setup>
import { FooterLinkBuilder, WrapperProps } from '~/components/Footer/FooterLink/FooterLink.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';
import { useUser } from '~/composables/custom/useUser/useUser';

const { $domain, $flags } = useNuxtApp();
const { isMobile } = useDevice();
const { isAuthenticated } = useUser();

const props = defineProps(WrapperProps);
const mgnlProps = FooterLinkBuilder.build(props);

const link = computed(() => {
  if (isAuthenticated.value && mgnlProps.authenticatedLink?.[0]) {
    return magnoliaGetters.getLinkAndName(mgnlProps.authenticatedLink[0], $domain.cmsAssetDomainPath, mgnlProps.intLinkParam);
  }
  if (isMobile && mgnlProps.mobileLink?.[0]) {
    return magnoliaGetters.getLinkAndName(mgnlProps.mobileLink[0], $domain.cmsAssetDomainPath, mgnlProps.intLinkParam);
  }
  return magnoliaGetters.getLinkAndName(
    {
      switchable: mgnlProps.switchable,
      linkTargetMode: mgnlProps.linkTargetMode,
      metadata: mgnlProps.metadata,
      title: mgnlProps.title,
    },
    $domain.cmsAssetDomainPath,
    mgnlProps.intLinkParam,
  );
});

const openCookieSettings = () => {
  if (typeof window.UC_UI !== 'undefined') {
    window.UC_UI.showSecondLayer();
  }
  else {
    // Giving extra time for script to be parsed/executed
    setTimeout(() => {
      try {
        window.UC_UI.showSecondLayer();
      }
      catch {
        throw Error('Ensure Usercentrics script is correctly loaded');
      }
    }, 1000);
  }
};
</script>
